<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'Product Center'"></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/product/banner01.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<!--位置-->
					<div ref="myElement" class="location_box">
						<div
							data-aos="fade-left"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="location_box_main"
						>
							<span @click="goHome" style="color: #333333;cursor: pointer;">Home</span>&ensp;/&ensp;<span>Product Center</span>
						</div>
					</div>
					<!--位置-->
					<!--筛选-->
					<div
						v-if="false"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="filter_box"
					>
						<div class="title">
							Screen
							<span @click="resetSearch">Reset</span>
						</div>
						<div v-if="solutionList.length > 0" class="filter_el">
							<div class="tit">Solution: </div>
							<div class="txt_box">
								<div class="txt" :class="isAll1 == 1 ? 'actived' : ''" @click="checkAll(1)">{{ isAll1 == 1 ? 'Unselect All' : 'All' }}</div>
								<div
									v-for="(value, index) in solutionList"
									:key="index" class="txt"
									:class="value.is_checked == 1 ? 'actived' : ''"
									@click="checkStatus(1, value)"
								>{{ value.title }}</div>
							</div>
						</div>
						<div v-if="productsTypeList.length > 0" class="filter_el">
							<div class="tit">Categorie: </div>
							<div class="txt_box">
								<div class="txt" :class="isAll2 == 2 ? 'actived' : ''" @click="checkAll(2)">{{ isAll2 == 2 ? 'Unselect All' : 'All' }}</div>
								<div
									v-for="(value, index) in productsTypeList"
									:key="index" class="txt"
									:class="value.is_checked == 1 ? 'actived' : ''"
									@click="checkStatus(2, value)"
								>{{ value.title }}</div>
							</div>
						</div>
						<div class="search_box">
							<div class="tit">Search: </div>
							<div class="input_box">
								<input v-model="inputVal" placeholder="Please enter keyword" @keyup.enter="searchClick" />
								<div class="icon">
									<van-icon name="search" color="#C8000A" size="24px" @click="searchClick" />
								</div>
							</div>
						</div>
					</div>
					<!--筛选-->
					<div style="padding: 40px 0;">{{ productTypeName ? productTypeName : 'ALl Product' }}</div>
					<div v-if="productsList.length > 0">
						<!--列表-->
						<div class="list_box">
							<div
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								v-for="(value, index) in productsList"
								:key="index"
								class="list_el"
								@click="goInfo(value)"
							>
								<div class="img_box">
									<img :src="webUrl + value.thumb" />
								</div>
								<div class="msg_box">
									<div class="tit">{{ value.name }}</div>
									<div class="btn_box">
										<div class="btn">More&ensp;<van-icon name="down" color="#C8000A" size="20px" style="top: 3px;transform: rotate(-90deg);" /></div>
									</div>
								</div>
							</div>
						</div>
						<!--列表-->
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="page_box"
						>
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="12"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						v-if="productsList.length == 0 && !listLoading"
					>
						<van-empty image="search" description="No Data" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { productSelectList, productList } from '@/api/public'  //产品筛选、列表
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			inputVal: '',
			page: 1,
			total: 0,
			listLoading: true,
			solutionList: [],  //解决方案
			productsTypeList: [],  //产品分类
			productsList: [],  //产品列表
			solutionId: [],
			cateId: [],
			isAll1: null,
			isAll2: null,
			productTypeName: null,
			webUrl: UPURL,
			lang: sessionStorage.getItem('lang')
		}
	},
	created(){
		let that = this;
		if(that.$route.query.scenarios_ids) {
			that.solutionId.push(that.$route.query.scenarios_ids);
		}
		if(that.$route.query.cate_ids) {
			that.cateId.push(that.$route.query.cate_ids);
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		//请求筛选条件
		// that.getFilter();
		//请求产品列表
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		goHome() {
			this.$router.push({ path: '/' });
		},
		//重置筛选条件
		resetSearch() {
			let that = this;
			that.solutionId = [];
			that.cateId = [];
			that.isAll1 = null;
			that.isAll2 = null;
			that.inputVal = '';
			that.page = 1;
			that.getFilter();
			that.getList();
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "ProductInfo", params: { productInfoId: value.id + '.html' } });
			// window.open(routeData.href, '_blank');
			window.location.href = routeData.href;
		},
		//点击搜索
		searchClick() {
			let that = this;
			if(that.inputVal) {
				that.getList();
			}else {
				that.$toast('Please enter keyword');
			}
		},
		//产品列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productList({
				keyword: that.inputVal,
				cate_ids: that.cateId.join(','),
				scenarios_ids: that.solutionId.join(','),
				page: that.page,
				page_size: 12,
				language: that.lang
			}).then(res => {
				that.productsList = res.data.productlist.data;
				that.total = res.data.productlist.total;
				that.productTypeName = res.data.catename;
				that.listLoading = false;
				that.$toast.clear();
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//全选
		checkAll(value) {
			let that = this;
			switch(value) {
				case 1:
					if(!that.isAll1) {
						that.isAll1 = value;
						that.solutionId = [];
						that.solutionList.forEach((value, index) => {
							value.is_checked = 1;
							that.solutionId.push(value.id);
						});
					}else {
						that.isAll1 = null;
						that.solutionId = [];
						that.solutionList.forEach((value, index) => {
							value.is_checked = 0;
						});
					}
				break;
				case 2:
					if(!that.isAll2) {
						that.isAll2 = value;
						that.cateId = [];
						that.productsTypeList.forEach((value, index) => {
							value.is_checked = 1;
							that.cateId.push(value.id);
						});
					}else {
						that.isAll2 = null;
						that.cateId = [];
						that.productsTypeList.forEach((value, index) => {
							value.is_checked = 0;
						});
					}
				break;
			}
			// console.log(that.solutionId);
			// console.log(that.cateId);
			that.getList();
		},
		//切换筛选条件
		checkStatus(type, value) {
			let that = this;
			that.solutionId = [];
			that.cateId = [];
			value.is_checked = !value.is_checked;
			that.solutionList.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.solutionId.push(value.id);
				}
			});
			that.productsTypeList.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.cateId.push(value.id);
				}
			});
			if(that.solutionId.length == that.solutionList.length) {
				that.isAll1 = 1;
			}else {
				that.isAll1 = null;
			}
			if(that.cateId.length == that.productsTypeList.length) {
				that.isAll2 = 2;
			}else {
				that.isAll2 = null;
			}
			// console.log(that.solutionId);
			// console.log(that.cateId);
			that.getList();
		},
		//筛选条件
		getFilter() {
			let that = this;
			productSelectList({
				language: that.lang,
				cate_ids: that.cateId.join(','),
				scenarios_ids: that.solutionId.join(',')
			}).then(res => {
				that.solutionList = res.data.scenarios_list;
				that.productsTypeList = res.data.cate_list;
			});
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//块1
	.block_1{
		background-color: #f6f6f6;
		.block_1_main{
			width: 1200px;
			margin: 0px auto;
			padding-bottom: 100px;
			//列表
			.list_box{
				.list_el:hover{
					transform: scale(1.02);
					box-shadow: 0px 0px 20px 1px rgba(0,0,0,0.08);
					img{
						transform: scale(1.1);
					}
				}
				.list_el{
					display: inline-block;
					// width: 400px;
					width: 362px;
					margin: 0 16.6px 50px 16.6px;
					cursor: pointer;
					background-color: #ffffff;
					transition: all 0.6s;
					.msg_box{
						padding: 30px 30px 50px 30px;
						.btn_box{
							margin-top: 24px;
							text-align: center;
							.btn:hover{
								border: 1px solid #C8000A;
								color: #ffffff;
								background-color: #C8000A;
								.van-icon{
									color: #ffffff !important;
								}
							}
							.btn{
								display: inline-block;
								padding: 10px 36px 12px 36px;
								font-size: 18px;
								border: 1px solid #EEEEEE;
								border-radius: 8px;
								line-height: 1;
							}
						}
						.tit{
							height: 70px;
							font-size: 18px;
							text-align: center;
							line-height: 2;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
					}
					.img_box{
						overflow: hidden;
						img{
							// width: 400px;
							// height: 400px;
							width: 362px;
							height: 362px;
							object-fit: cover;
							transition: all 0.6s;
						}
					}
				}
			}
			//筛选
			.filter_box{
				padding: 80px 0;
				.search_box{
					display: flex;
					margin: 15px 0 0 0;
					.input_box{
						width: 364px;
						position: relative;
						.icon{
							position: absolute;
							right: 10px;
							top: 4px;
							cursor: pointer;
						}
						input:focus{
							border: 1px solid #C8000A;
						}
						input{
							position: relative;
							top: -10px;
							left: 12px;
							width: 100%;
							height: 54px;
							padding: 0 56px 0 28px;
							font-size: 18px;
							border: 1px solid #EEEEEE;
							color: #C8000A;
							background-color: transparent;
							border-radius: 8px;
						}
					}
					.tit{
						width: auto;
						font-size: 18px;
					}
				}
				.filter_el{
					display: flex;
					margin: 15px 0;
					.txt_box{
						flex: 1;
						.txt:hover{
							color: #C8000A;
							// border: 1px solid #C8000A;
						}
						.txt.actived:first-child{
							background-color: transparent;
							color: #C8000A;
							// border: 1px solid #C8000A;
						}
						.txt.actived{
							background-color: #C8000A;
							color: #ffffff;
						}
						.txt{
							display: inline-block;
							position: relative;
							top: -4px;
							margin: 0 10px 20px 10px;
							padding: 14px 24px 10px 24px;
							font-size: 16px;
							line-height: 1;
							border: 1px solid #EEEEEE;
							border-radius: 8px;
							cursor: pointer;
							user-select: none;
						}
					}
					.tit{
						width: auto;
						font-size: 18px;
					}
				}
				.title{
					padding-bottom: 20px;
					font-size: 24px;
					span{
						display: inline-block;
						font-size: 16px;
						margin-left: 30px;
						cursor: pointer;
						user-select: none;
					}
				}
			}
			//分页
			.page_box{
				padding-top: 50px;
				text-align: center;
			}
			//位置
			.location_box{
				background-color: #f6f6f6;
				.location_box_main{
					padding: 40px 0 0 0;
					span{
						color: #999999;
					}
				}
			}
		}
	}
	//轮播
	.banner_box{
		img{
			width: 100%;
			min-width: 1200px;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>